import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * Configuración de MSAL para autenticación con Azure AD (Microsoft 365)
 * 
 * IMPORTANTE: Antes de usar, debes registrar la aplicación en Azure AD:
 * 1. Ve a Azure Portal > Azure Active Directory > App registrations
 * 2. Crea una nueva aplicación
 * 3. Configura los Redirect URIs (SPA): http://localhost:5173, https://tu-dominio.com
 * 4. Copia el Application (client) ID y Directory (tenant) ID
 * 5. Actualiza las variables de entorno
 */

// Configuración de MSAL
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Más seguro que localStorage
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            // Solo en desarrollo
            if (import.meta.env.DEV) {
              console.info(message);
            }
            break;
          case LogLevel.Verbose:
            if (import.meta.env.DEV) {
              console.debug(message);
            }
            break;
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Error,
    },
  },
};

// Scopes para la autenticación
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Scopes para llamadas a la API (si necesitas acceso a Graph API u otras)
export const apiRequest = {
  scopes: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`],
};

// Validar configuración
export const isAuthConfigured = (): boolean => {
  const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
  const tenantId = import.meta.env.VITE_AZURE_TENANT_ID;
  return !!(clientId && tenantId && clientId !== '' && tenantId !== '');
};
